import { CircularProgress } from "@mui/material";
import { GridActionsCellItem, GridColDef } from "@mui/x-data-grid";
import { createElement } from "react";
import { TbChecks, TbPlayerPlay } from "react-icons/tb";

import { buildDepartureProcessItem } from "@/pages/HotelPlanning/departure/utils/process";
import useHotelDepartureProgress from "@/providers/hooks/useHotelDeparture";
import { IHotelPlanningDepartureResponseItem } from "@/schemas/hotelPlanningDepartureSchema";

import HotelDepartureActionsHeader from "./HotelDepartureActionsHeader";

export enum HotelDepartureClickActionNames {
    START_TRANSFER = "START_TRANSFER",
    COMPLETE_TRANSFER = "COMPLETE_TRANSFER",
}

export const hotelDepartureActions: {
    label: string;
    icon: React.ElementType;
    color: string;
    showInMenu?: boolean;
    onClick: HotelDepartureClickActionNames;
    mobile: boolean;
}[] = [
    {
        label: "Transferi Başlat",
        icon: TbPlayerPlay,
        color: "primary",
        onClick: HotelDepartureClickActionNames.START_TRANSFER,
        mobile: true,
        showInMenu: true,
    },
    {
        label: "Transferi Tamamla",
        icon: TbChecks,
        color: "accent",
        onClick: HotelDepartureClickActionNames.COMPLETE_TRANSFER,
        mobile: true,
        showInMenu: true,
    },
];

function TrackingActionsColumn({
    allRows,
}: {
    allRows: IHotelPlanningDepartureResponseItem[];
}): GridColDef<IHotelPlanningDepartureResponseItem> {
    return {
        field: "actions",
        type: "actions",
        width: 60,
        cellClassName: "!px-2",
        pinnable: true,
        filterable: false,
        editable: false,
        disableColumnMenu: true,
        renderHeader: () => <HotelDepartureActionsHeader allRows={allRows} />,

        getActions: (params) => {
            const { handleHotelDepartureProgress, isPending } = useHotelDepartureProgress();

            const row = params.row;
            // Both variants gate on an assigned driver; custom also needs a task. buildDepartureProcessItem
            // returns null when the action isn't available for this row (→ action hidden).
            const startItem = buildDepartureProcessItem(row, "start");
            const completeItem = buildDepartureProcessItem(row, "complete");

            const clickActions: Record<HotelDepartureClickActionNames, { cb: () => void; cond: boolean }> = {
                [HotelDepartureClickActionNames.START_TRANSFER]: {
                    cb: async () => startItem && handleHotelDepartureProgress([startItem]),
                    cond: !!startItem,
                },
                [HotelDepartureClickActionNames.COMPLETE_TRANSFER]: {
                    cb: async () => completeItem && handleHotelDepartureProgress([completeItem]),
                    cond: !!completeItem,
                },
            };

            return hotelDepartureActions
                .filter((action) => clickActions[action.onClick].cond)
                .map((action) => (
                    <GridActionsCellItem
                        icon={createElement(isPending ? CircularProgress : action.icon, { size: 14 })}
                        label={action.label}
                        onClick={clickActions[action.onClick].cb}
                        color={action.color}
                        showInMenu={action.showInMenu as true}
                        key={action.label}
                        disabled={isPending}
                    />
                ));
        },
    };
}

export default TrackingActionsColumn;
